import { Resources } from 'constants/resources';

import { ResourceProps } from 'react-admin';

import { ProvidersCreate } from './ProvidersCreate';
import { ProvidersEdit } from './ProvidersEdit/ProvidersEdit';
import { ProvidersList } from './ProvidersList/ProvidersList';
import { ProvidersShow } from './ProvidersShow/ProvidersShow';

export const providersResource: ResourceProps = {
  name: Resources.Providers,
  create: ProvidersCreate,
  edit: ProvidersEdit,
  list: ProvidersList,
  show: ProvidersShow,
};
